module.exports = __webpack_public_path__ + "img/dsci0070.42ed9324.jpg";